import { render, staticRenderFns } from "./newst.vue?vue&type=template&id=e8a07d3c&scoped=true"
import script from "./newst.vue?vue&type=script&lang=ts"
export * from "./newst.vue?vue&type=script&lang=ts"
import style0 from "./newst.vue?vue&type=style&index=0&id=e8a07d3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a07d3c",
  null
  
)

export default component.exports